/* tslint:disable */
/* eslint-disable */
/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { SystemMessagePostPut } from '../models';
// @ts-ignore
import { SystemMessageResponse } from '../models';
/**
 * SystemMessageApi - axios parameter creator
 * @export
 */
export const SystemMessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [dateTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemMessagesGetSystemMessageByFilterGet: async (dateTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/systemMessages/getSystemMessageByFilter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (dateTime !== undefined) {
                localVarQueryParameter['dateTime'] = (dateTime as any instanceof Date) ?
                    (dateTime as any).toISOString() :
                    dateTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemMessagesGetSystemMessageGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/systemMessages/getSystemMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new  SystemMessage
         * @param {SystemMessagePostPut} [systemMessagePostPut] error type info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemMessagesUpdatePost: async (systemMessagePostPut?: SystemMessagePostPut, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/systemMessages/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemMessagePostPut, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemMessageApi - functional programming interface
 * @export
 */
export const SystemMessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemMessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [dateTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemMessagesGetSystemMessageByFilterGet(dateTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemMessagesGetSystemMessageByFilterGet(dateTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemMessagesGetSystemMessageGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemMessagesGetSystemMessageGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new  SystemMessage
         * @param {SystemMessagePostPut} [systemMessagePostPut] error type info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemMessagesUpdatePost(systemMessagePostPut?: SystemMessagePostPut, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemMessagesUpdatePost(systemMessagePostPut, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemMessageApi - factory interface
 * @export
 */
export const SystemMessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemMessageApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [dateTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemMessagesGetSystemMessageByFilterGet(dateTime?: string, options?: any): AxiosPromise<SystemMessageResponse> {
            return localVarFp.apiSystemMessagesGetSystemMessageByFilterGet(dateTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemMessagesGetSystemMessageGet(options?: any): AxiosPromise<SystemMessageResponse> {
            return localVarFp.apiSystemMessagesGetSystemMessageGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new  SystemMessage
         * @param {SystemMessagePostPut} [systemMessagePostPut] error type info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemMessagesUpdatePost(systemMessagePostPut?: SystemMessagePostPut, options?: any): AxiosPromise<void> {
            return localVarFp.apiSystemMessagesUpdatePost(systemMessagePostPut, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemMessageApi - object-oriented interface
 * @export
 * @class SystemMessageApi
 * @extends {BaseAPI}
 */
export class SystemMessageApi extends BaseAPI {
    /**
     * 
     * @param {string} [dateTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemMessageApi
     */
    public apiSystemMessagesGetSystemMessageByFilterGet(dateTime?: string, options?: AxiosRequestConfig) {
        return SystemMessageApiFp(this.configuration).apiSystemMessagesGetSystemMessageByFilterGet(dateTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemMessageApi
     */
    public apiSystemMessagesGetSystemMessageGet(options?: AxiosRequestConfig) {
        return SystemMessageApiFp(this.configuration).apiSystemMessagesGetSystemMessageGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new  SystemMessage
     * @param {SystemMessagePostPut} [systemMessagePostPut] error type info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemMessageApi
     */
    public apiSystemMessagesUpdatePost(systemMessagePostPut?: SystemMessagePostPut, options?: AxiosRequestConfig) {
        return SystemMessageApiFp(this.configuration).apiSystemMessagesUpdatePost(systemMessagePostPut, options).then((request) => request(this.axios, this.basePath));
    }
}
